$(document).ready(function(){
  $(".scs-currency-block .dropdown-toggle").click(function(){
    $("#dropdown-cart").hide();
    $("[data-popup-video]").hide();
    $(this).parent().find(".dropdown-menu").slideToggle();
  });
  
  $("#currency_form .scs-currency-selector").on("change blur",function(){
      $(this).closest("form").find("[name=return_to]").val(window.location.pathname+window.location.search);
      $(this).closest("form").submit();
  });

  
  $(".currency-mobile.scs-currency-selector").on("change blur",function(){
      $("#currency_form .scs-currency-selector").val($(this).val());
      $(this).closest("form").find("[name=return_to]").val(window.location.pathname+window.location.search);
      $("#currency_form .scs-currency-selector").closest("form").submit();
  });
  
  
   $(".scs-currency-block .currency-menu .dropdown-item").click(function(e){
      e.preventDefault();
      $(".scs-currency-selector").val($(this).data("currency"));
      $(this).closest("form").find("[name=return_to]").val(window.location.pathname+window.location.search);
      $(this).closest("form").submit();
  });

  $(document).click(function (e) {
    if (!$(e.target).closest("#currency_form").length) {

      $(".currency-dropdown .currency-menu").slideUp();
    }
  });
});